import { render, staticRenderFns } from "./PendingGathering.vue?vue&type=template&id=f2628cb0&scoped=true&"
import script from "./PendingGathering.vue?vue&type=script&lang=js&"
export * from "./PendingGathering.vue?vue&type=script&lang=js&"
import style0 from "./PendingGathering.vue?vue&type=style&index=0&id=f2628cb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2628cb0",
  null
  
)

export default component.exports